import { AddCircleOutline, AttachFile, BookmarkBorderOutlined, FolderOpen, PostAdd, PublishedWithChanges } from "@mui/icons-material";
import { Box, DialogContent, DialogTitle, Grid, InputLabel, styled, SvgIcon, Typography } from "@mui/material";

export const StyledGestionDeObra = {
    GridItemAligned: styled(SvgIcon)(({ theme }) => ({
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        margin: "10px",
    })),
    GridRowItem: styled(Grid)(({ theme }) => ({
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
    })),
    GestionObraIcon: styled(PostAdd)(({ theme }) => ({
        color: theme.palette.tertiary.main,
    })),
    ProgramaSeguridadIcon: styled(AttachFile)(({ theme }) => ({
        color: theme.palette.quartary.main,
    })),
    FormularioCargadoIcon: styled(FolderOpen)(({ theme }) => ({
        color: theme.palette.quinary.main,
    })),
    CertificadoPresentacionIcon: styled(BookmarkBorderOutlined)(({ theme }) => ({
        color: theme.palette.quartary.light,
    })),
    FinalizarObraIcon: styled(PublishedWithChanges)(({ theme }) => ({
        color: theme.palette.primary.main,
    })),
    DisabledIcon: styled(SvgIcon)(({ theme }) => ({
        color: theme.palette.primary.grey,
    })),
    DetailPanel: styled(Box)(({ theme }) => ({
        width: '100%',
        background: theme.palette.tertiary.grey,
    })),
};

export const StyledProgramaSeguridad = {
    TitleContainer: styled(DialogTitle)(({ theme }) => ({
        backgroundColor: theme.palette.primary.main,
        borderBottom: "1px solid green",
        boxSizing: "border-box",
        textAlign: "center",
        color: "white",
        padding: "5px 120px 5px 120px",
    })),
    DialogContent: styled(DialogContent)(({ theme }) => ({
        padding: "25px",
        display: "flex",
        justifyContent: "center",
    })),
    ContentWrapper: styled("div")(({ theme }) => ({
        width: "100%",
        maxWidth: "500px",
    })),
    TextBlock: styled("div")(({ theme }) => ({
        width: "75%",
        margin: "auto",
        marginBottom: "16px",
    })),
    DropzoneContainer: styled("div")(({ theme }) => ({
        marginTop: "20px",
    })),
    Title: styled(Typography)(({ theme }) => ({
        marginBottom: "24px",
        fontWeight: "bold",
    })),
    FoliosRow: styled(Grid)(({ theme }) => ({
        marginBottom: "16px",
    })),
    Label: styled(Typography)(({ theme }) => ({
        marginBottom: "8px",
    })),
}

export const StyledNuevaObra = {
    BreadcrumbContainer: styled("div")(({ theme }) => ({
        display: "flex",
        margin: "15px",
    })),
    HeaderLabel: styled("div")(({ theme }) => ({
        margin: "15px",
    })),
    GridContainer: styled(Grid)(({ theme }) => ({
        paddingRight: "35px",
        paddingLeft: "35px",
        paddingTop: "15px",
        alignItems: "center"
    })),
    RadioContainer: styled("div")(({ theme }) => ({
        marginTop: "10px",
        marginLeft: "30px",
    })),
    PaddingContainer: styled(Grid)(({ theme }) => ({
        padding: "20px",
    })),
    FormikInput: styled("div")(({ theme }) => ({
        margin: "20px",
        marginTop: 0,
    })),
    FormikRadio: styled("div")(({ theme }) => ({
        marginTop: "20px",
    })),
    ButtonContainer: styled("div")(({ theme }) => ({
        display: "flex",
        justifyContent: "flex-end",
        padding: "10px",
    })),
    ContainerMultiline: styled("div")(({ theme }) => ({
        marginLeft: "50px",
        marginRight: "50px",
        marginTop: "10px"
    })),
    TableContainer: styled("div")(({ theme }) => ({
        paddingBottom: "20px"
    })),
    WarningRes319: styled("div")(({ theme }) => ({
        paddingTop: '110px'
    })),
    LabelContainer: styled("div")(({ theme }) => ({
        display: "flex",
        margin: "25px",
        padding: "10px",
        backgroundColor: theme.palette.tertiary.light,
        width: "fit-content",
        borderRadius: "10px",
        color: theme.palette.tertiary.main,
        alignItems: "center",
    })),
    Icon: styled(SvgIcon)(({ theme }) => ({
        marginRight: "15px",
    })),
    HeaderLabelChildrenContainer: styled("div")(({ theme }) => ({
        display: "flex",
        justifyContent: "space-evenly",
    })),
    HeaderSecondItem: styled(Typography)(({ theme }) => ({
        paddingLeft: "30px",
    })),
    HeaderThirdItem: styled(Typography)(({ theme }) => ({
        paddingLeft: "20px",
    })),
    GrupoTitulo: styled(Typography)(({ theme }) => ({
        margin: "15px",
        color: theme.palette.primary.main,
        borderBottom: `solid 2px ${theme.palette.primary.main}`,
    })),
}

export const StyledUbicacionObra = {
    Flex: styled("div")(({ theme }) => ({
        display: "flex",
    })),
    Title: styled(InputLabel)(({ theme }) => ({
        padding: "10px",
        fontSize: "18px",
    })),
    LatLongContainer: styled("div")(({ theme }) => ({
        padding: "2px",
    })),
    Icon: styled(AddCircleOutline)(({ theme }) => ({
        color: "white",
    })),
    TextValue: styled(Typography)(({ theme }) => ({
    })),
    Latitud: styled(InputLabel)(({ theme }) => ({
        paddingBottom: "10px",
    })),
    Longitud: styled(InputLabel)(({ theme }) => ({
        paddingBottom: "10px",
    })),
    LatitudContainer: styled("div")(({ theme }) => ({
        marginRight: "10px",
        textAlign: "center",
    })),
    LongitudContainer: styled("div")(({ theme }) => ({
        marginLeft: "10px",
        textAlign: "center",
    })),
}